import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_2 = { class: "pt-1 pb-1 forms_field-headline" };
const _hoisted_3 = { class: "fw-bold" };
const _hoisted_4 = {
    key: 0,
    class: "fst-italic"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.element.label)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.element.label), 1),
                (_ctx.element.subLabel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.element.subLabel), 1))
                    : _createCommentVNode("", true)
            ])
        ]))
        : _createCommentVNode("", true);
}
